export default {"src":"/_next/static/media/HyperFavicon.b0ffff5c.svg","height":192,"width":192};